import {
  FETCH_CONSOLE_LOGS_LOADING,
  FETCH_CONSOLE_LOGS_SUCCESS,
  FETCH_CONSOLE_LOGS_FAILED,
  CLEAR_CONSOLE_LOGS,
  FETCH_CONSOLE_LOGS_COUNT_SUCCESS,
  FETCH_CONSOLE_LOGS_PAGE_LOADING
} from "../../actionTypeConstants/ml2.0/ConsoleLogs";
import get from "lodash/get";

const initialState = {
  data: null,
  url: "",
  loading: true,
  error: null,
  consoleLogPageCount: 0,
  currentPageOffset: 0,
  paginationLoading: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_CONSOLE_LOGS_LOADING: {
      return {
        ...state,
        loading: true,
        data: null,
        error: null
      };
    }

    case FETCH_CONSOLE_LOGS_SUCCESS: {
      const fetchFromLTMA = get(
        action,
        ["payload", "areLogsFetchedFromLTMA"],
        false
      );
      const url = get(action, ["result", "config", "url"], "");
      const pageIndex = get(action, ["payload", "pageIndex"], 0);

      let data = fetchFromLTMA
        ? get(action, ["result", "data"], "")
        : get(action, ["result", "data", "data"], "");

      //append console logs of all pages
      if (pageIndex > 1) {
        data = [...state.data, ...data];
      }

      return {
        ...state,
        loading: false,
        paginationLoading: false,
        currentPageOffset: pageIndex || 0,
        url: url,
        data: data,
        error: null
      };
    }

    case FETCH_CONSOLE_LOGS_FAILED: {
      return {
        ...state,
        loading: false,
        paginationLoading: false,
        error: action.error.response
      };
    }

    case CLEAR_CONSOLE_LOGS: {
      return {
        ...state,
        loading: false,
        data: null,
        error: null
      };
    }

    case FETCH_CONSOLE_LOGS_COUNT_SUCCESS: {
      const data = get(action, ["result", "data", "data"], []);
      const pageCount = Array.isArray(data) ? data.length : 0;
      return {
        ...state,
        loading: false,
        consoleLogPageCount: pageCount
      };
    }

    case FETCH_CONSOLE_LOGS_PAGE_LOADING: {
      return {
        ...state,
        paginationLoading: true
      };
    }

    default: {
      return state;
    }
  }
}
